import { createStore, applyMiddleware, compose } from "redux";

import { logger } from "@jslib/shared/utils/logger";
import { getSafe } from "@jslib/shared/utils/getSafe";

import {
  type ReduxState,
  type VerificationResponseAction,
  type VerificationServiceAction,
  type VerificationStore,
} from "../types/types";
import { getOptions } from "../../options/options";

import { verificationServiceReducer } from "./verificationServiceReducer";
import { verificationStoreMiddleware } from "./VerificationServiceStoreMiddleware";

let store: VerificationStore;

export const getStore = (): VerificationStore => {
  if (!store) {
    const composeEnhancers =
      // @ts-expect-error There's no type expansion on window for Redux DevTools.
      (typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

    store = createStore<ReduxState, VerificationServiceAction, void, void>(
      verificationServiceReducer,
      composeEnhancers(applyMiddleware(verificationStoreMiddleware)),
    );
    logger.init(() => {
      const state = store.getState();
      const errorIds = getSafe(() => state.verificationResponse.errorIds);
      return {
        programId: getSafe(() => state.programId),
        isLoading: getSafe(() => state.isLoading),
        isErrored: getSafe(() => state.isErrored),
        errorIdsFromVerRsp: Array.isArray(errorIds) ? errorIds.join(", ") : undefined,
        verificationId: getSafe(() => state.verificationResponse.verificationId),
        currentStep: getSafe(() => state.verificationResponse.currentStep),
        locale: getSafe(() => state.programTheme.intl.locale),
        isTestMode: getSafe(() => state.programTheme.isTestMode),
        openOrgSearchEnabled: getSafe(() => state.programTheme.openOrgSearchEnabled),
        /** @deprecated : Remove once NR has been updated to use clientVersion (HC-1665) */
        jslibVerActual: getSafe(() => process.env.NEXT_VERSION, "?"),
        clientVersion: getSafe(() => process.env.NEXT_VERSION, "?"),
      };
    });
  }

  return store;
};

export const resetStore = () => getStore().dispatch({ type: "RESET_STATE" });

export const refreshStore = (): void => {
  // This prompts the form to re-render which it otherwise wouldn't because a new verification is requested only on mount
  if (getOptions().mockResponse) {
    getStore().dispatch<VerificationResponseAction>({
      verificationResponse: getOptions().mockResponse,
      type: "VERIFICATION_RESPONSE",
    });
  }
  getStore().dispatch({ type: "FORCE_UPDATE" });
};
